// extracted by mini-css-extract-plugin
export default {"subTitle":"githubStats_subTitle__IAO2S","stats":"githubStats_stats__gc2iQ","githubCalender":"githubStats_githubCalender__8GhIr"};